import { t } from '@lingui/core/macro';
import { createFileRoute } from '@tanstack/react-router';

import { ChangePasswordForm } from './-components/change-password-form';
import { SettingsSection } from './-components/settings-section';
import { SETTINGS_HELP } from './-utils/help-articles';

export const Route = createFileRoute(
  '/researchers/_authenticated/settings/password',
)({
  component: PasswordPage,
  head: () => ({ meta: [{ title: t`Change password` }] }),
});

function PasswordPage() {
  return (
    <SettingsSection
      helpUrl={SETTINGS_HELP.general}
      title={t`Change password`}
      description={t`Accounts that sign in through their organization's single sign-on manage their password there.`}
    >
      <ChangePasswordForm />
    </SettingsSection>
  );
}
